import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../pages/Authentication/Login";
import Register from "../pages/Authentication/Register";
import { PublicRoute } from "./ProtectedRoute";
import FormRender from "../pages/FormBuilder/FormRender";
import ExternalFormRender from "../pages/FormBuilder/ExternalFormRender";
import { FormsProvider } from "../contexts/FormsContext";
import AuthLayout from "../layouts/AuthLayout";
import OnboardingFormPage from "../pages/FormBuilder/OnboardingFormPage";
import CampaignDetails from "../pages/Campaigns/CampaignDetails";
import ApplicationFormPage from "../pages/FormBuilder/ApplicationFormPage";

const AuthRoutes = () => {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <AuthLayout>
            <PublicRoute>
              <Login />
            </PublicRoute>
          </AuthLayout>
        }
      />
      <Route
        path="/register"
        element={
          <AuthLayout>
            <PublicRoute>
              <Register />
            </PublicRoute>
          </AuthLayout>
        }
      />

      <Route
        path="/forms_/:id"
        element={
          <FormsProvider mode="external">
            {/* <PublicRoute> */}
              <ExternalFormRender />
            {/* </PublicRoute> */}
          </FormsProvider>
        }
      />

      <Route
        path="/on-boarding/:token?"
        element={
          // <PublicRoute>
            <OnboardingFormPage />
          // </PublicRoute>
        }
      />

      <Route
        path="/application-form"
        element={
          // <PublicRoute>
            <ApplicationFormPage />
          // </PublicRoute>
        }
      />

      <Route
        path="/campaign/:id"
        element={
          // <PublicRoute>
            <CampaignDetails />
          // </PublicRoute>
        }
      />
      
      <Route path="*" element={<Login />} /> {/* Fallback to Login */}
    </Routes>
  );
};

export default AuthRoutes;
